import { getLocale, tns } from './common';

export const tv = (key, locale = getLocale()) => tns('videoDetail', key, locale);

export default { tv };


